import { useMemo, useState } from "react";

import * as Api from "@/api";
import Valkyrie, {
  viPhoneArrowDownLeft,
  viPhoneArrowDownLeftProhibited,
  viPhoneArrowUpRight,
  viPhoneArrowUpRightProhibited,
  viSpinnerThird,
  viTrashCan,
} from "@sippy-platform/valkyrie";

import { Box, IconButton, ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import PropTypes from "prop-types";

function RuleButton({ blocklist, rule, blocklistDispatch, setActiveRule, activeRule }) {
  const [processing, setProcessing] = useState(false);

  const directionIsDisabledWithBlockingRule = useMemo(
    () =>
      ((rule.direction === "out" && !blocklist.allowExternalOut) ||
        (rule.direction === "in" && !blocklist.allowExternalIn)) &&
      !rule.allowed,
    [rule, blocklist],
  );

  function deleteRule() {
    setProcessing(true);

    Promise.resolve(Api.deleteBlocklistRule(blocklist, rule))
      .then(() => {
        blocklistDispatch({ type: "deleteRule", rule });

        if (activeRule.id === rule.id) {
          setActiveRule(null);
        }
      })
      .finally(() => setProcessing(false));
  }

  return (
    <ListItem
      disablePadding
      key={rule.input}
      secondaryAction={
        rule.id && (
          <IconButton onClick={deleteRule}>
            <Valkyrie icon={processing ? viSpinnerThird : viTrashCan} spin={processing} />
          </IconButton>
        )
      }
    >
      <ListItemButton selected={activeRule?.id === rule.id} onClick={() => setActiveRule(rule)} id={`rule${rule.id}`}>
        <ListItemIcon
          sx={(theme) => ({
            color: rule.allowed ? "success.main" : "error.main",
            ...theme.applyStyles("dark", {
              color: rule.allowed ? "success.main" : "error.main",
            }),
          })}
        >
          <Valkyrie
            icon={
              rule.direction === "out"
                ? rule.allowed
                  ? viPhoneArrowUpRight
                  : viPhoneArrowUpRightProhibited
                : rule.allowed
                  ? viPhoneArrowDownLeft
                  : viPhoneArrowDownLeftProhibited
            }
          />
        </ListItemIcon>
        <ListItemText
          primary={rule.prefix}
          secondary={
            directionIsDisabledWithBlockingRule ? (
              <>
                <Box component="span" sx={{ color: "error.main" }}>
                  This rule is redundant
                </Box>
                {rule.description && <> &middot; {rule.description}</>}
              </>
            ) : (
              rule.description
            )
          }
        />
      </ListItemButton>
    </ListItem>
  );
}

RuleButton.propTypes = {
  blocklist: PropTypes.object,
  rule: PropTypes.object,
  setActiveRule: PropTypes.func,
  activeRule: PropTypes.object,
  blocklistDispatch: PropTypes.func,
};

export default RuleButton;
